import { ErrorBoundary } from 'components/common/error-boundary';
import { MachineBurnInRouter } from 'components/sections/admin-portal/machines/dialogs/settings/machine-burn-in/router';
import { MachineBurnInTable } from 'components/sections/admin-portal/machines/dialogs/settings/machine-burn-in/table';
import useBurnInTestStore from 'components/sections/admin-portal/machines/dialogs/settings/machine-burn-in/use-burn-in-test-store';
import { useMachinesPortalStore } from 'components/sections/admin-portal/machines/store/use-machines-portal-store';
import { useEffect } from 'react';
import { AdminBurnInTestsService } from 'services/admin/machine-burn-in-tests.service';

const COMPONENT_NAME = 'MachineBurnIn';

export const MachineBurnIn = () => {
  const machine = useMachinesPortalStore((s) => s.machine);
  const activeTestID = useBurnInTestStore((s) => s.activeTestID);

  useEffect(() => {
    // reset everything when the machine changes
    useBurnInTestStore.getState().reset();

    if (!machine?.machineID) {
      // nothing new to load
      return;
    }

    // load the burn-in tests for this machine
    AdminBurnInTestsService.getInstance()
      .search({ machineID: machine.machineID })
      .then((results) => useBurnInTestStore.setState({ tests: results }));
  }, [machine?.machineID]);

  if (activeTestID) {
    // for performing the selected test and/or viewing the report after
    return (
      <ErrorBoundary identifier={COMPONENT_NAME}>
        <MachineBurnInRouter />
      </ErrorBoundary>
    );
  }

  // for selecting which test to review/resume
  return (
    <ErrorBoundary identifier={COMPONENT_NAME}>
      <MachineBurnInTable />
    </ErrorBoundary>
  );
};
